import { imageTypes } from '../constants/commonConstants';

import baseService from './baseService';

export function uploadImage(file, type) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  const data = new FormData();
  if (file[0]) {
    data.append('image_type', imageTypes[type[0]]);
    data.append('image', file[0]);
  }
  if (file[1]) {
    data.append('user_image_type', imageTypes[type[1]]);
    data.append('user_image', file[1]);
  }

  return baseService.post('/images', data, config);
}

export function uploadImportImage(data) {
  return baseService.post('/images', {
    url: data,
  });
}
